import { SET_SETTINGS, SET_SELECTION } from '../actions';

export default (state = { cssOpen: false, selectionResult: null }, action) => {
  switch (action.type) {
    case SET_SETTINGS:
      return {
        ...state,
        cssOpen: action.payload
      }
      case SET_SELECTION:
      return {
        ...state,
        selectionResult: action.payload
      }
    default:
      return state
  }
}
